// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1JVBw","alertIcon":"ConfirmModal_alertIcon__vYn3x"};